import { ISimilarNewbuildingSchema } from '../../../repositories/newbuilding-card/entities/similar_newbuilding/SimilarNewbuildingSchema';
import { INewbuildingFromTheBuilderSchema } from '../../../repositories/newbuilding-card/entities/newbuilding_from_the_builder/NewbuildingFromTheBuilderSchema';

export function getJKInfo(
  jk: ISimilarNewbuildingSchema | INewbuildingFromTheBuilderSchema,
  position: number,
  list: string,
) {
  if (!jk) {
    return {};
  }

  return {
    id: jk.newbuildingId,
    offerType: 'JK',
    position,
    extra: {
      name: jk.name,
      brand: `${jk.builderIds && jk.builderIds.join(',')}/developer_company`,
      category: 'sale/JK',
      list,
    },
  };
}
